
import React from 'react';
import { Route } from 'react-router-dom';
import StaffDashboard from '@/pages/StaffDashboard';
import PatientManagement from '@/pages/staff/PatientManagement';
import PatientDetail from '@/pages/staff/PatientDetail';
import PatientAppointments from '@/pages/staff/PatientAppointments';
import PatientCredits from '@/pages/staff/PatientCredits';
import PaymentProcessing from '@/pages/staff/PaymentProcessing';
import StaffTreatments from '@/pages/staff/StaffTreatments';
import StaffReports from '@/pages/staff/StaffReports';
import StaffSettings from '@/pages/staff/StaffSettings';
import StaffTraining from '@/pages/staff/StaffTraining';
import RoleProtectedRoute from '@/components/RoleProtectedRoute';

export const EnhancedStaffRoutes = () => (
  <>
    {/* Staff Dashboard */}
    <Route 
      path="/app/staff/dashboard" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <StaffDashboard />
        </RoleProtectedRoute>
      } 
    />

    {/* Staff Training - NEW */}
    <Route 
      path="/app/staff/training" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <StaffTraining />
        </RoleProtectedRoute>
      } 
    />

    {/* Staff Patients */}
    <Route 
      path="/app/staff/patients" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <PatientManagement />
        </RoleProtectedRoute>
      } 
    />
    
    <Route 
      path="/app/staff/patients/:id" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <PatientDetail />
        </RoleProtectedRoute>
      } 
    />

    {/* Staff Treatments */}
    <Route 
      path="/app/staff/treatments" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <StaffTreatments />
        </RoleProtectedRoute>
      } 
    />

    {/* Staff Appointments */}
    <Route 
      path="/app/staff/appointments" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <PatientAppointments />
        </RoleProtectedRoute>
      } 
    />

    {/* Staff Credits */}
    <Route 
      path="/app/staff/credits" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <PatientCredits />
        </RoleProtectedRoute>
      } 
    />

    {/* Staff Payments */}
    <Route 
      path="/app/staff/payments" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <PaymentProcessing />
        </RoleProtectedRoute>
      } 
    />

    {/* Staff Reports */}
    <Route 
      path="/app/staff/reports" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <StaffReports />
        </RoleProtectedRoute>
      } 
    />

    {/* Staff Settings */}
    <Route 
      path="/app/staff/settings" 
      element={
        <RoleProtectedRoute allowedRoles={['coordinator', 'admin']}>
          <StaffSettings />
        </RoleProtectedRoute>
      } 
    />
  </>
);
